
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/subscribe",
      function () {
        return require("private-next-pages/subscribe.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/subscribe"])
      });
    }
  